import React, { useEffect, useState } from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export const EMAIL_FORMAT = /^[^@\s,;]+@[^@\s,;]+\.[^@\s,;]+$/;

// Live email check under an input: format, "did you mean…?" typo hint, domain can receive mail.
export const EmailCheckHint = ({ value, onUse, testId = 'email-check' }) => {
  const { api } = useAuth();
  const [r, setR] = useState(null);
  useEffect(() => {
    const v = (value || '').trim();
    if (!v || v.length < 4) { setR(null); return undefined; }
    const t = setTimeout(() => {
      api.get('/email/check', { params: { address: v } }).then(({ data }) => setR({ ...data, v })).catch(() => setR(null));
    }, 900);
    return () => clearTimeout(t);
  }, [api, value]);
  if (!r || r.v !== (value || '').trim()) return null;
  if (!r.ok) return <p data-testid={`${testId}-error`} className="mt-1 text-xs text-rose-700 flex items-center gap-1"><AlertTriangle size={12} />{r.error}</p>;
  if (r.suggestion) return (
    <p data-testid={`${testId}-suggestion`} className="mt-1 text-xs text-amber-800 flex items-center gap-1">
      <AlertTriangle size={12} />Did you mean <b>{r.suggestion}</b>?
      {onUse && <button type="button" data-testid={`${testId}-use-suggestion`} onClick={() => onUse(r.suggestion)} className="underline font-semibold">Use it</button>}
    </p>
  );
  return <p data-testid={`${testId}-ok`} className="mt-1 text-xs text-emerald-700 flex items-center gap-1"><CheckCircle2 size={12} />Looks good</p>;
};
